<template>
  <Card :bordered="false" class="customflow-container" dis-hover>
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_month') }}</p>
    </div>
    <div ref="todolist" class="charts-body">
      <div id="examine-approve"></div>
    </div>
  </Card>
</template>

<script>
import api from '../../../api/home/index';
import moment from 'moment';
import * as echarts from 'echarts';
import { getLanguage } from 'wdz-common-components/src/common/js/ovoSystem';
export default {
  data() {
    return {
      myChart: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    myEchartsResize() {
      this.myChart && this.myChart.resize();
    },
    getData() {
      let startApplyTime = moment().month(moment().month()).startOf('month').format('YYYY-MM-DD HH:mm:ss');
      let endApplyTime = moment().month(moment().month()).endOf('month').format('YYYY-MM-DD HH:mm:ss');
      api
        .getFlowInstanceCount({ startApplyTime, endApplyTime })
        .then(res => {
          this.data = res;
          this.formatChartData(this.data);
        })
        .catch(error => {
          console.error(`获取审批信息异常：${error}`);
        });
    },
    formatChartData(data) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('examine-approve'), null, { renderer: 'svg' });
      const totalNum = data.otherHandledNum + data.pendingNum + data.myApplied + data.ccUnReadNum + data.handledNum;
      let option = {
        tooltip: {
          trigger: 'item',
          position: 'left',
        },
        color: ['#295EFF', '#7ED321', '#FF9900', '#16DFB0', '#E85FFF'],
        grid: {
          right: '3%',
          containLabel: true,
        },
        legend: {
          orient: 'vertical',
          x: 'left',
          y: 'center',
          itemHeight: 12, //图例的高度
          itemWidth: 12,
          itemGap: 20,
          icon: 'circle',
          textStyle: {
            rich: {
              n: {
                display: 'inline-block',
                width: 80,
                color: '#7F7F7F',
              },
              v: {
                display: 'inline-block',
                width: 50,
              },
            },
          },
          //图例-待审批，已审批，抄送我的 他人已审批 我发起的
          data: [
            this.$t('common.status5'), //'待审批',
            this.$t('home.audited'), //'已审批',
            this.$t('home.cc_to_me'), //'抄送我的',
            this.$t('home.audited_by_others'), //'他人已审批',
            this.$t('home.initiated'), //'我发起的',
          ],
          formatter: function (name) {
            let index = 0;
            option.series[0].data.forEach((val, i) => {
              if (val.name === name) {
                index = i;
              }
            });
            if (getLanguage() == 'zh-CN' || getLanguage() == 'zh-TW') {
              return `{n|${name}} {v|${option.series[0].data[index].value}}`;
            } else {
              return `{n|${name}}                 {v|${option.series[0].data[index].value}}`;
            }
          },
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: ['65%', '75%'],
            center: ['66%', '50%'], //距离左右，上下距离的百分比
            avoidLabelOverlap: false,
            hoverOffset: 5,
            label: {
              show: true,
              position: 'center',
              formatter: `{b|${totalNum}}\n${this.$t('common.all')}`,
              rich: {
                b: {
                  fontSize: 20,
                  fontWeight: 'bold',
                  color: '#333333',
                  lineHeight: '26',
                },
              },
            },
            data: [
              {
                value: data.pendingNum,
                name: this.$t('common.status5'), //'待审批',
              },
              {
                value: data.handledNum,
                name: this.$t('home.audited'), //'已审批',
              },
              {
                value: data.ccUnReadNum,
                name: this.$t('home.cc_to_me'), //'抄送我的',
              },
              {
                value: data.otherHandledNum,
                name: this.$t('home.audited_by_others'), //'他人已审批',
              },
              {
                value: data.myApplied,
                name: this.$t('home.initiated'), //'我发起的',
              },
            ],
          },
        ],
      };
      // 绘制图表
      myChart.setOption(option);
      this.myChart = myChart;
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: #f0f0f0;
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}
.customflow-container {
  .charts-body {
    @include wh100;
    #examine-approve {
      width: 100%;
      height: 100%;
    }
  }
  .echart-container {
    @include wh100;
  }
}
</style>
